import {isSensorIdentifier} from './isSensorIdentifier';
import {CsvConfigJsonResult} from '../synoptic-configuration-csv-types';

export function isShowTooltipArgs(obj: any): CsvConfigJsonResult {
  let valid = true;
  let errors = [];

  if (obj.title === undefined) {
    valid = false;
    errors.push({code: 'notExist', key: 'title'});
  } else if (typeof obj.title !== 'string') {
    valid = false;
    errors.push({code: 'notText', key: 'title', value: obj.title});
  }

  if (obj.showDates === undefined) {
    valid = false;
    errors.push({code: 'notExist', key: 'showDates'});
  } else if (typeof obj.showDates !== 'boolean') {
    valid = false;
    errors.push({code: 'notBoolean', key: 'showDates', value: obj.showDates});
  }

  if (!Array.isArray(obj.rows)) {
    valid = false;
    errors.push({code: 'notArray', key: 'rows'});
  } else {
    obj.rows.forEach((row) => {
      const result = isTooltipRow(row);
      if (!result.result) {
        valid = false;
        errors = [...errors, ...result.errors];
      }
    });
  }


  return {result: valid, errors: errors};
}

function isTooltipRow(obj: any): CsvConfigJsonResult {
  let valid = true;
  let errors = [];

  if (obj.label === undefined) {
    valid = false;
    errors.push({code: 'notExist', key: 'label'});
  } else if (typeof obj.label !== 'string') {
    valid = false;
    errors.push({code: 'notText', key: 'label', value: obj.label});
  }

  if (obj.value === undefined) {
    valid = false;
    errors.push({code: 'notExist', key: 'value'});
  } else {
    const resultIsSensorIdentifier = isSensorIdentifier(obj.value);
    if (!resultIsSensorIdentifier.result) {
      valid = false;
      errors = [...errors, ...resultIsSensorIdentifier.errors];
    }
  }

  return {result: valid, errors: errors};
}
